import React, { useRef, useState, cloneElement, ReactElement } from "react";
import { Overlay, Popover } from "react-bootstrap";

type ClickableElement = React.ReactElement<{
  onClick?: React.MouseEventHandler;
  style?: React.CSSProperties;
}>;


interface DeleteConfirmActionProps {
  top?: any,
  triggerElement: ClickableElement;
  confirmText: React.ReactNode;
  onConfirm: () => void;
  onCancel?: () => void;
  onCloseMenu?: () => void;
}

export const DeleteConfirmAction: React.FC<DeleteConfirmActionProps> = ({
  triggerElement,
  confirmText,
  onConfirm,
  onCancel,
  onCloseMenu,
}) => {
  const [show, setShow] = useState(false);
  const targetRef = useRef<HTMLElement | null>(null);

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    onCloseMenu?.();
  };

  const trigger = cloneElement(triggerElement, {
    onClick: (e: React.MouseEvent<HTMLElement>) => {
      triggerElement.props.onClick?.(e);

      if (!e.defaultPrevented) {
        e.stopPropagation();
        targetRef.current = e.currentTarget;
        setShow(true);
      }
    },
  });

  return (
    <>
      {trigger}
      <Overlay
        target={targetRef.current}
        show={show}
        placement="top"
        container={document.body}
        rootClose
        popperConfig={{
          modifiers: [
            {
              name: "preventOverflow",
              options: { boundary: "viewport" },
            },
          ],
        }}
      >

        <Popover style={{ minWidth: 270, zIndex: 1109 }}>
          <Popover.Body>
            <div className="mb-2">{confirmText}</div>

            <div className="d-flex justify-content-end">
              <button
                className="btn btn-sm btn-outline-secondary me-2"
                onClick={() => {
                  onCancel?.();
                  handleClose();
                }}
              >
                Отмена
              </button>

              <button
                className="btn btn-sm btn-outline-danger"
                onClick={() => {
                  onConfirm();
                  handleClose();
                }}
              >
                Удалить
              </button>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </>
  );
};
